import {
  Component,
  ViewEncapsulation,
  ContentChildren,
  HostBinding,
} from '@angular/core';
import { PgButtonComponent } from './pg-button.component';

@Component({
  selector: 'pg-button-group, grit-button-group',
  templateUrl: './pg-button-group.component.html',
  styleUrls: ['./pg-button-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PgButtonGroupComponent {
  @HostBinding('class.grit-button-group')
  @HostBinding('class.pg-button-group')
  _pgButtonGroupClass = true;
  @ContentChildren(PgButtonComponent) _buttonChildren: PgButtonComponent;
  constructor() {}
}
